module.exports = __webpack_public_path__ + "assets/img/preview_01.a4cf00a0.png";